



















import { Component, Prop, Vue } from "vue-property-decorator";
import { IContract, IContractProduct } from "@/models/contracts";

@Component({
  components: {
    "cprod-provider": () =>
      import("@/components/app/global/contractProducts/cProdProvider.vue"),
    "cprod-secrets-component": () =>
      import("@/components/app/global/contractProducts/cProdSecretsComp.vue")
  }
})
export default class CProdSecretsModal extends Vue {
  // Props

  @Prop({ required: true })
  public contractId!: IContract["id"];

  @Prop({ default: null })
  public productId!: IContractProduct["id"];
}
